var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "editable",
          rawName: "v-editable",
          value: _vm.blok,
          expression: "blok",
        },
      ],
      staticClass: "column",
      class: _vm.styleClasses,
      style: _vm.styleFromProps,
    },
    _vm._l(_vm.blok.body, function (blok) {
      return _c(blok.component, {
        key: blok._uid,
        tag: "component",
        attrs: { blok: blok, publishedAt: _vm.publishedAt },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }